import React, { useEffect } from "react";
import CollectifAnnuaireItemContact from "./CollectifAnnuaireItemContact";
import useApiUrlTranslation from "./useApiUrlTranslation";
import HTMLReactParser from "html-react-parser";
import { use } from "i18next";
import { useFormContext } from "react-hook-form";


const RegistrationFormCycleLangListItemSection = ({ cycle_lang, isChildren, formulaire }) => {

    const { t } = useApiUrlTranslation();

    const { register } = useFormContext();

    if (!formulaire) {
        return null;
    }

    return (<>
        <div className={`   align-items-center ${isChildren ? "ml-10 " : "mt-2"}`} key={cycle_lang.id_cycle_lang}>
            <label className={`flex items-center space-x-3 f ${isChildren ? "font-normal " : ""}`}>
                <input type="checkbox"
                    {...register("cycleLangIdEventContactTypeList")}
                    value={JSON.stringify({ id_cycle_lang: cycle_lang.id_cycle_lang, id_event_contact_type: formulaire.id_event_contact_type_main })}
                />
                <img
                    style={{ width: isChildren ? "20px" : "30px" }}
                    src={typeof cycle_lang.logo_better === 'object' ? cycle_lang.logo_better.small : cycle_lang.logo_better_url}
                    alt=""
                    className={`${cycle_lang.cycle_lang_state == "draft" && 'grayscale'}  rounded `} />
                <p className={`uppercase ${isChildren ? "text-sm" : ""}`}>{cycle_lang.nom_cycle_lang}</p>
            </label>
        </div>
        {cycle_lang.children && cycle_lang.children
            //trier par child.nom_cycle_lang
            .sort((a, b) => a.nom_cycle_lang.localeCompare(b.nom_cycle_lang))
            .filter(child => child.cycle_lang_state == 'active')
            .map((child) => <RegistrationFormCycleLangListItemSection
                cycle_lang={child}
                formulaire={formulaire}
                isChildren />)}
    </>
    )
}

export default RegistrationFormCycleLangListItemSection;